module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0140.jpg?v=9b15f9a6";